const formatPriceGBP = (price = 0) =>
  price.toLocaleString("en-GB", { style: "currency", currency: "GBP" });

export { formatPriceGBP };
